export default {"src":"/_next/static/media/CECA_ICONOS_Hogar_05.1fd5766a.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};